import { render } from "./ContentPlaceholdersHeading.vue?vue&type=template&id=e20c6462"
import script from "./ContentPlaceholdersHeading.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholdersHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__